import { useMemo } from 'react'

import { useSafetyCaseStatusesQuery, useTagsQuery } from '../../../../services'
import { useProfile } from '../../../../security'
import { TagCategory } from '../../../../interfaces'
import { toOptions } from '../../../../util'

const useSafetyCaseFilterQueries = () => {
  const { airportId } = useProfile()
  const statusesQuery = useSafetyCaseStatusesQuery({ activeOnly: true })

  const statusOptions = useMemo(
    () =>
      (statusesQuery?.data || []).map(status => ({
        label: status.name,
        value: status.id,
      })),
    [statusesQuery?.data],
  )

  const tagsQuery = useTagsQuery({ airportId }, { tagCategory: TagCategory.SafetyCase })

  const tagsOptions = useMemo(() => toOptions(tagsQuery?.data), [tagsQuery?.data])

  const booleanSearchOptions = [
    { label: 'All', value: 0 },
    { label: 'Yes', value: 1 },
    { label: 'No', value: 2 },
  ]

  return {
    statusesQuery,
    statusOptions,
    tagsQuery,
    tagsOptions,
    booleanSearchOptions,
  }
}

export default useSafetyCaseFilterQueries
